/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : MSAConfirmConfiguration.tsx
*
* Project Title : Checkout
*
* Description   : Initial version
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : Deepthi B (E844276)
*
* @Date         : Oct 17, 2019
*
* @Version      : Version 1.0
*
* By           : Deepthi Bachu (E844276)
* On           : Oct 17, 2019
* Description  : Updated code as per ASDS-1583
*
* By           : Deepthi Bachu (E844276)
* On           : Oct 23, 2019
* Description  : Updated code as per ASDS-404
 *
 * By            : H224423
 * On            : Dec 3, 2019
 * Description   : ASDS-1995 - UI Issue Fixes.
 *
 * By            : H422335
 * On            : Sep 24 2020
 * Description   : ASDS-3045 - APU Phase 2 UI Enhancements
******************************************************************************/
import * as React from 'react';
import '@scuf/common/honeywell/theme.css';
import { connect } from 'react-redux';
import './ConfigureAPU.css';
import ConfigureAPUActions from '../redux/actions/configure-apu-actions';
import DisplayCustTypeCard from './DisplayCustTypeCard';
import CheckoutConstants from '../constants/checkout-constants';
import DisplayProductCardMSA from './DisplayProductCardMSA';
import DisplayTotalPriceCard from './TotalPriceCard';

interface IConfigureProductProps {
    gotoCustomerCategoryTab: Function;
    gotoProductConfigureTab: Function;
    totalPrice: any;
    productData: IMSAProductData[];
}
interface IMSAProductData {
    soldTo: string;
    contractNo: string;
    expirationDate: string;
    aircraftOem: string;
    serialNumber: string;
    unitPrice: string;
}

class MSAConfirmConfiguration extends React.Component<IConfigureProductProps, any> {
    render() {
        return(
            <div>
                <DisplayCustTypeCard gotoCustomerCategoryTab={this.props.gotoCustomerCategoryTab} customerType={CheckoutConstants.CUSTOMER_CATEGORY_MSA}/>
                <DisplayProductCardMSA gotoProductConfigureTab={this.props.gotoProductConfigureTab} productConfigData={this.props.productData} />
                <DisplayTotalPriceCard totalPrice={this.props.totalPrice}/>
            </div>
        );
    }
}

const mapDispatchToProps = {
    gotoCustomerCategoryTab: ConfigureAPUActions.gotoCustomerCategoryTab,
    gotoProductConfigureTab: ConfigureAPUActions.gotoProductConfigureTab,
};

function mapStateToProps(state) {
    return {
        totalPrice: state.configAPUData.payload.totalPrice,
        productData: state.configAPUData.payload.msaConfigData,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MSAConfirmConfiguration);

export { MSAConfirmConfiguration };